/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/25
 */
import './index.css';
import fetchJsonp from 'fetch-jsonp';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Select from '../select';
import omit from 'omit.js';
// 其他街道输入
// import Input from '../input';
// {streetId === 0 ? <Input placeholder="其他" /> : null}
// inputRegExp = /^[\u4E00-\u9FA5A-Za-z0-9_\-\(\)\（\）]+$/;


class Address extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onError: PropTypes.func,
    displayKey: PropTypes.string,
    valueKey: PropTypes.string,
    fetch: PropTypes.func
  };
  static defaultProps = {
    displayKey: 'name',
    valueKey: 'id',
    onError: () => {},
    onChange: () => {},
    fetch: (pid) => {
      return new Promise((resolve, reject) => {
        fetchJsonp(`//area.meizu.com/area/child/query/${pid}`)
          .then(res => res.json())
          .then(res => {
            if (res.success) {
              resolve(res.data);
            }
          })
          .catch(err => reject('地址服务器跑丢啦~', err));
      });
    }
  };
  prefix = 'store-address';
  state = {
    data: {},
    provinceId: null,
    province: null,
    cityId: null,
    city: null,
    areaId: null,
    area: null,
    streetId: null,
    street: null
  };
  typeOrder = ['province', 'city', 'area', 'street'];
  constructor (props) {
    super(props);
    const { onError, fetch, displayKey, valueKey } = this.props;
    this.selectConfig = { displayKey, valueKey, notFoundContent: '请按顺序选择' };
    fetch(0)
      .then(data => this.handleFetchResolve(data, '0'))
      .catch(err => onError(err));
  }
  handleChange (name, id, type) {
    const { onError, fetch, onChange } = this.props;
    const state = {
      [type]: name,
      [`${type}Id`]: id
    }
    const start = this.typeOrder.indexOf(type) + 1;
    for (let i = start; i < 4; i++) {
      const name = this.typeOrder[i];
      Object.assign(state, {
        [name]: null,
        [`${name}Id`]: null
      });
    }
    this.setState(state);
    onChange(name, id, type, omit(Object.assign({}, this.state, state), ['data']))
    if (!this.state.data[id]) {
      fetch(id)
        .then(data => this.handleFetchResolve(data, id, this.typeOrder[start]))
        .catch(err => onError(err));
    } else if (this.state.data[id].length === 1 && start !== 4) {
      const nextType = this.typeOrder[start];
      const { id: nextId, name: nextName } = this.state.data[id][0];
      this.setState({
        [nextType]: nextName,
        [`${nextType}Id`]: nextId
      });
      this.handleChange(nextName, nextId, nextType);
    }
  }
  handleFetchResolve (data, pid, type) {
    this.setState(prevState => ({
      data: Object.assign({}, prevState.data, { [pid]: data })
    }));
    if (data.length === 1 && type) {
      const { name, id } = data[0];
      this.setState({
        [type]: name,
        [`${type}Id`]: id
      });
      this.handleChange(name, id, type);
    }
  }
  render () {
    const { data, provinceId, cityId, areaId } = this.state;
    return <div className={this.prefix}>
      <Select list={data[0] || []}
              text={this.state.province}
              value={this.state.provinceId}
              placeholder="省/直辖市" {...this.selectConfig}
              onChange={(name, id) => this.handleChange(name, id, 'province')} />
      <Select list={data[provinceId] || []}
              text={this.state.city}
              value={this.state.cityId}
              placeholder="城市" {...this.selectConfig}
              onChange={(name, id) => this.handleChange(name, id, 'city')} />
      <Select list={data[cityId] || []}
              text={this.state.area}
              value={this.state.areaId}
              placeholder="区/县" {...this.selectConfig}
              onChange={(name, id) => this.handleChange(name, id, 'area')} />
      <Select list={data[areaId] || []}
              text={this.state.street}
              value={this.state.streetId}
              placeholder="乡镇/街道" {...this.selectConfig}
              onChange={(name, id) => this.handleChange(name, id, 'street')} />
    </div>
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/lib/address/index.js